import { Directive, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { CommandController } from '../../../core/component/base/command-controller.base';
import { ColumnDefinition } from '../../../core/model/column-definition';
import { MenuItemDefinition } from '../../../core/model/menu-item-definition';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { vacantRentalObjectCommand } from '../../model/const/command';
import { RentalObjectCategory } from '../../model/const/enums';
import { VacantCommandHandlerResolver } from '../../service/command/vacant-command-handler-resolver.service';
import { ColumnDefinitionService } from '../../service/data/column-definition.service';
import { VacantRentalObjectService } from '../../service/data/vacant-period.service';
import { VacantRentalObject } from '../../model/vacant-rental-object';

@Directive()
export abstract class VacantRentalObjectComponentBase extends CommandController implements OnInit {
  constructor(
    private _columnDefinitionService: ColumnDefinitionService,
    private _messageService: MessageService,
    protected navigation: NavigationService,
    private _service: VacantRentalObjectService,
    dispatcher: CommandDispatcher,
    handlerResolver: VacantCommandHandlerResolver
  ) {
    super(dispatcher, handlerResolver);
    this.menuDefinition = [
      new MenuItemDefinition('VACANT_RENTAL_OBJECT_LIST.CREATE_LEASE_AGREEMENT_BTN', vacantRentalObjectCommand.createContract),
    ];
  }

  private _getDataSubscription: Subscription;
  protected abstract get category(): RentalObjectCategory;
  columnDefinition: ColumnDefinition[];
  itemsSource: VacantRentalObject[];
  menuDefinition: MenuItemDefinition[];

  ngOnDestroy() {
    super.ngOnDestroy();
    if (this._getDataSubscription) {
      this._getDataSubscription.unsubscribe();
      this._getDataSubscription = null;
    }
  }

  ngOnInit(): void {
    if (this.category === RentalObjectCategory.Dwelling)
      this.columnDefinition = this._columnDefinitionService.create('VacantRentalObjectDwelling');
    if (this.category === RentalObjectCategory.Parking)
      this.columnDefinition = this._columnDefinitionService.create('VacantRentalObjectParking');
    if (this.category === RentalObjectCategory.Premises)
      this.columnDefinition = this._columnDefinitionService.create('VacantRentalObjectPremises');
    if (this.category === RentalObjectCategory.Other) this.columnDefinition = this._columnDefinitionService.create('VacantRentalObject');

    this._getDataSubscription = this._service.getOverview(this.category).subscribe(
      data => {
        this.itemsSource = data;
      },
      error => this._messageService.showError(error)
    );
  }
}
